<template>
	<div class="page-wrapper">
		<div class="topbar">
			<img :src="isDark ? logoDark : logoLight" alt="Gigahost" class="topbar-logo">
		</div>
		<div class="not-found">
			<h2>Whoops! Are you sure this is the correct link?</h2>
			<router-link to="/report">
				<button class="btn btn-primary">&laquo; Go back</button>
			</router-link>
		</div>
		<div class="footbar">
			&copy; {{ currentYear }} - Gigahost AS
		</div>
	</div>
</template>

<script>
import logoLight from '../assets/logo.png'
import logoDark from '../assets/logo-dark.png'

export default {
	name: 'Notfound',
	data() {
		return {
			logoLight,
			logoDark,
			isDark: document.documentElement.getAttribute('data-theme') === 'dark'
		}
	},
	computed: {
		currentYear() {
			return new Date().getFullYear()
		}
	}
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap');

.page-wrapper {
	min-height: 100vh;
	background: var(--color-bg-page);
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
	color: var(--color-text-primary);
	display: flex;
	flex-direction: column;
}

.topbar {
	max-width: 760px;
	margin: 0 auto;
	padding: 24px 16px 0;
	width: 100%;
	box-sizing: border-box;
}

.topbar-logo {
	width: 180px;
	height: auto;
}

.not-found {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 0 16px;
}

.not-found h2 {
	font-size: 20px;
	font-weight: 600;
	margin-bottom: 24px;
}

.btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border: none;
	cursor: pointer;
	font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
	font-size: 14px;
	font-weight: 600;
	transition: background-color 0.15s;
}

.btn-primary {
	background: var(--color-btn-primary-bg);
	color: var(--color-btn-primary-text);
	border-radius: 10px;
	padding: 12px 24px;
}

.btn-primary:hover {
	background: var(--color-btn-primary-hover);
}

.footbar {
	max-width: 760px;
	margin: 0 auto;
	padding: 40px 16px;
	text-align: center;
	font-size: 12px;
	color: var(--color-text-muted);
}
</style>
